export default {
  DEFAULT: {
    fields: [
      { name: 'document', orderField: '', label: 'Document' },
      { name: 'ts', orderField: '', label: 'Expiration Date' },
      { name: 'action', label: '' },
    ],
  },
};
